import { createContext, useContext, useState } from "react";

const ResultContext = createContext()

export const ResultContextProvider = ({ children }) => {

  const [name, setName] = useState("")
  const [firstName, setFirstName] = useState("")
  const [mail, setMail] = useState("")
  const [mailConfirm, setMailConfirm] = useState("")
  const [company, setCompany] = useState("")

  const [consent, setConsent] = useState(false)

  const emailRegex = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9-]+\.[A-Za-z0-9-]+/gm

  const resetConfiguration = () => {
    setName("")
    setFirstName("")
    setMail("")
    setMailConfirm("")
    setCompany("")
    setConsent(false)
  }

  const regexValid = emailRegex.test(mail)
  const mailIsValid = regexValid && mail !== '' && mail === mailConfirm

  const resultIsValid =
    name !== '' &&
    firstName !== '' &&
    mailIsValid &&
    consent

  return (
    <ResultContext.Provider value={{
      name, setName,
      firstName, setFirstName,
      mail, setMail,
      mailConfirm, setMailConfirm,
      company, setCompany,
      consent, setConsent,
      resetConfiguration,
      regexValid,
      mailIsValid,
      resultIsValid
    }}>
      {children}
    </ResultContext.Provider>
  )
}

export const ResultData = () => {
  return useContext(ResultContext)
}